import { render, staticRenderFns } from "./CustomerUserStatus.vue?vue&type=template&id=60b2b42c&"
import script from "./CustomerUserStatus.vue?vue&type=script&lang=js&"
export * from "./CustomerUserStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports